import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c92a461e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Submit Portfolio", -1))
const _hoisted_4 = { class: "auto-resizable-iframe" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "uploader-video-wrapper" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  "z-index": "100",
  class: "video-modal",
  controls: "",
  preload: "false",
  crossorigin: "anonymous",
  cors: "anonymous",
  "data-setup": "{}",
  style: {}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Submit", -1))

import {getCurrentInstance, ref, computed} from "vue";
import {
  FormInst, FormRules, FormValidationError, FormItemRule, UploadInst, UploadFileInfo,
  NForm, NFormItem, NInput, NSelect, NButton, NUpload, NSpace, NGrid,
  NGridItem, NTabs, NTabPane, NUploadDragger, NText, NIcon
} from "naive-ui";
import {WindowClose, FileUploadOutline, Youtube} from "mdue";
import axios from 'axios';
import store from '@/store/index.js'
import {useRouter} from "vue-router";
import {ValidateError} from "async-validator";
import {QuillEditor} from "@vueup/vue-quill";

interface PortfolioModel {
  title: string
  type: string
  description: string | null
  youtube_url: string | null
  file_url: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitPortfolio',
  setup(__props) {

const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message
const maxAudioSize = ref(app!.appContext.config.globalProperties.maxAudioSize)
const maxAudioSizeMB = (maxAudioSize.value / (1024 ** 2)).toFixed()
const maxImageSize = ref(app!.appContext.config.globalProperties.maxImageSize)
const maxImageSizeMB = (maxImageSize.value / (1024 ** 2)).toFixed()
const maxVideoSize = ref(app!.appContext.config.globalProperties.maxVideoSize)
const maxVideoSizeMB = (maxVideoSize.value / (1024 ** 2)).toFixed()
const router = useRouter()
const tabs = ref(null)
const tabsValue = ref('')
const form = ref<FormInst | null>(null)
const upload = ref<UploadInst | null>(null)
const model = ref<PortfolioModel>({
  title: "",
  description: "<p></p>",
  type: "Text",
  youtube_url: null,
  file_url: null
})
const rules: FormRules = {
  title: [{
    key: "title",
    required: true,
    message: 'Title cannot be empty',
    trigger: ['change']
  }],
  youtube_url: [{
    key: "youtube_url",
    required: true,
    message: "URL cannot be empty",
    trigger: ['input']
  }, {
    key: "youtube_url",
    validator: (rule: FormItemRule, value: any) => {
      return !!ytEmbed.value
    },
    message: "URL tidak valid",
    trigger: ['input']
  }]
}

const ytrx = new RegExp("^.*(?:(?:youtu\\.be\\/|v\\/|vi\\/|u\\/\\w\\/|embed\\/)|(?:(?:watch)?\\?v(?:i)?=|\\&v(?:i)?=))([^#\\&\\?]*).*")

function getYoutubeId(url: string | null | undefined) {
  if (!url)
    return null
  const res = url.match(ytrx)
  return res ? res[1] : ""
}

const ytEmbed = computed(() => {
  const ytId = getYoutubeId(model.value!.youtube_url)
  return ytId ? `https://youtube.com/embed/${ytId}` : null
})

//Audio File
//https://en.wikipedia.org/wiki/HTML5_audio
const audioTypes = ["audio/wav", "audio/mpeg", "audio/aac", "audio/flac"]
const audioFile = ref<File | null>(null)
const audioFileFeedback = ref<string | null>()
const audioFileUrl = ref<string | null>(null)

function validateAudio(file: File) {
  if (!audioTypes.includes(file.type)) {
    return "Unsupported format. Supported formats are MP3, WAV, FLAC, and AAC."
  }
  if (file.size > maxAudioSize.value) {
    return `File size must not exceed ${maxAudioSizeMB}MB.`
  }
  return null
}

function handleAudioChange(data: any) {
  const file = data.file.file

  audioFile.value = null
  audioFileUrl.value = null
  audioFileFeedback.value = null

  const feedback = validateAudio(file)
  if (feedback) {
    audioFileFeedback.value = feedback
    return
  }

  audioFile.value = file
  audioFileUrl.value = URL.createObjectURL(file)
}

function closeAudioPreview(e: PointerEvent) {
  e.preventDefault()
  e.stopPropagation()
  audioFile.value = null
  audioFileUrl.value = null
  audioFileFeedback.value = null
}

//Image File
const imageTypes = ["image/png", "image/svg+xml", "image/jpeg", "image/webp"]
const imageFile = ref<File | null>(null)
const imageFileFeedback = ref<string | null>()
const imageFileUrl = ref<string | null>('')

function validateImage(file: File) {
  if (!imageTypes.includes(file.type)) {
    return "Unsupported format. Supported formats are JPEG, PNG, WebP, and SVG."
  }
  if (file.size > maxImageSize.value) {
    return `File size must not exceed ${maxImageSizeMB}MB.`
  }
  return null
}

function handleImageChange(data: any) {
  const file = data.file.file

  imageFile.value = null
  imageFileUrl.value = null
  imageFileFeedback.value = null

  const feedback = validateImage(file)
  if (feedback) {
    imageFileFeedback.value = feedback
    return
  }

  imageFile.value = file
  imageFileUrl.value = URL.createObjectURL(file)
}

function closeImagePreview(e: PointerEvent) {
  e.preventDefault()
  e.stopPropagation()
  imageFile.value = null
  imageFileUrl.value = null
  imageFileFeedback.value = null
}

// Video File

const videoTypes = ["video/mp4", "video/quicktime", "video/x-matroska", "video/x-msvideo"]
const videoFile = ref<File | null>(null)
const videoFileFeedback = ref<string | null>()
const videoFileUrl = ref<string | null>('')

function validateVideo(file: File) {
  console.log(file.type)
  console.log(file.size + ' ' + maxVideoSize.value)
  if (!videoTypes.includes(file.type)) {
    return "Unsupported format. Supported formats are MP4, Quicktime, and MKV/Matroska."
  }
  if (file.size > maxVideoSize.value) {
    return `File size must not exceed ${maxVideoSizeMB}MB.`
  }
  return null
}

function handleVideoChange(data: any) {
  const file = data.file.file

  console.log(data)

  videoFile.value = null
  videoFileUrl.value = null
  videoFileFeedback.value = null

  const feedback = validateVideo(file)
  if (feedback) {
    videoFileFeedback.value = feedback
    return
  }

  videoFile.value = file
  videoFileUrl.value = URL.createObjectURL(file)
  console.log(videoFileUrl.value)
}

function closeVideoPreview(e: PointerEvent) {
  e.preventDefault()
  e.stopPropagation()
  videoFile.value = null
  videoFileUrl.value = null
  videoFileFeedback.value = null
}

// General

const submitLoading = ref(false)

function back() {
  router.push("/portfolio")
}

async function handleSubmit(e: MouseEvent) {
  e.preventDefault()
  let err: ValidateError[][] = []
  await form.value!.validate(
      undefined,
      rule => {
        return (rule as any).key == "title"
      }
  ).catch(errors => err = err.concat(errors))

  let title = model.value!.title
  let description = model.value!.description
  let type = (tabs.value as any).mergedValue || "text"
  let youtube_url = ""
  let file_url: File | string = ""
  switch (type) {
    case "youtube":
      await form.value!.validate(
          undefined,
          rule => {
            return (rule as any).key == "youtube_url"
          }
      ).catch(errors => err = err.concat(errors))
      youtube_url = ytEmbed.value || ""
      break
    case "audio":
      if (!audioFile.value) {
        audioFileFeedback.value = "File cannot be empty"
      }
      if (audioFileFeedback.value) {
        err.push([{message: audioFileFeedback.value}])
        break
      }
      file_url = audioFile.value as any
      break
    case "image":
      if (!imageFile.value) {
        imageFileFeedback.value = "File cannot be empty"
      }
      if (imageFileFeedback.value) {
        err.push([{message: imageFileFeedback.value}])
        break
      }
      file_url = imageFile.value as any
      break
    case "video":
      if (!videoFile.value) {
        videoFileFeedback.value = "File cannot be empty"
      }
      if (videoFileFeedback.value) {
        err.push([{message: videoFileFeedback.value}])
        break
      }
      file_url = videoFile.value as any
      break
  }

  if (err.length) {
    message.error("Form is not filled correctly", {showIcon: true, closable: true})
    return
  }

  let formData = new FormData()
  formData.append("type", type.charAt(0).toUpperCase() + type.slice(1))
  formData.append("title", title)
  formData.append("description", description as any)
  formData.append("youtube_url", youtube_url as any)
  formData.append("file_url", file_url)
  submitLoading.value = true
  axios.post('api/portfolio/', formData,
      {headers: {Authorization: `Bearer ${store.state.token}`}}
  ).then(response => {
    message.success("Portfolio is successfully saved!", {showIcon: true, closable: true})
    submitLoading.value = false
    router.push('/portfolio')
  }).catch(error => {
    console.log(error)
    message.error("A problem is occurred when saving portfolio", {showIcon: true, closable: true})
  }).finally(() => {
    submitLoading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NSpace), {
        vertical: "",
        align: "center"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_unref(NForm), {
        ref_key: "form",
        ref: form,
        model: model.value,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGrid), {
            cols: 2,
            "x-gap": 20,
            "y-gap": 16,
            "item-responsive": "",
            responsive: "screen"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NGridItem), { span: "2 s:1" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    label: "Title",
                    path: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        id: "title",
                        size: "large",
                        value: model.value.title,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.title) = $event)),
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createTextVNode(" Description "),
                    _createVNode(_unref(QuillEditor), {
                      theme: "snow",
                      "content-type": "html",
                      content: model.value.description,
                      "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((model.value.description) = $event))
                    }, null, 8, ["content"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(NGridItem), { span: "2 s:1" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), { label: "Portfolio Type" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NTabs), {
                        ref_key: "tabs",
                        ref: tabs,
                        "default-value": "text",
                        value: tabsValue.value,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((tabsValue).value = $event)),
                        "justify-content": "space-evenly",
                        type: "segment"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NTabPane), {
                            name: "text",
                            tab: "Text"
                          }),
                          _createVNode(_unref(NTabPane), {
                            name: "youtube",
                            tab: "YouTube"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NGrid), {
                                cols: 1,
                                "y-gap": 8
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NGridItem), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NFormItem), {
                                        first: "",
                                        path: "youtube_url",
                                        "show-label": false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(NInput), {
                                            id: "youtube_url",
                                            value: model.value.youtube_url,
                                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((model.value.youtube_url) = $event)),
                                            size: "large",
                                            placeholder: "Enter URL Video",
                                            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(NGridItem), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_unref(NIcon), {
                                          size: "128",
                                          depth: 5
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Youtube))
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("div", null, [
                                          (_unref(ytEmbed))
                                            ? (_openBlock(), _createElementBlock("iframe", {
                                                key: 0,
                                                title: "Youtube Portfolio",
                                                src: _unref(ytEmbed),
                                                allowfullscreen: "allowfullscreen"
                                              }, null, 8, _hoisted_5))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTabPane), {
                            name: "audio",
                            tab: "Audio"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), { "show-label": false }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NUpload), {
                                    ref: "formAudio",
                                    class: "upload-form",
                                    multiple: false,
                                    max: 1,
                                    "default-upload": false,
                                    onChange: handleAudioChange
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NUploadDragger), null, {
                                        default: _withCtx(() => [
                                          (audioFile.value || audioFileUrl.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_unref(NButton), {
                                                  text: "",
                                                  class: "close-btn",
                                                  onClick: closeAudioPreview
                                                }, {
                                                  icon: _withCtx(() => [
                                                    _createVNode(_unref(NIcon), null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(WindowClose))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("audio", {
                                                  controls: "",
                                                  src: audioFileUrl.value
                                                }, null, 8, _hoisted_7)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (!(audioFile.value || audioFileUrl.value))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_unref(NIcon), {
                                                    size: "48",
                                                    depth: 3
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(FileUploadOutline))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createVNode(_unref(NText), { style: {"font-size":"16px"} }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Drag file or click to upload ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(NText), {
                                                  type: audioFileFeedback.value ? 'error' : '',
                                                  depth: "3",
                                                  style: {"margin":"8px 0 0 0"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(audioFileFeedback.value || "Max size is " + maxAudioSize.value / (1024 ** 2) + "MB. Supported formats are MP3, WAV, FLAC, and AAC."), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["type"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTabPane), {
                            name: "image",
                            tab: "Picture"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), { "show-label": false }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NUpload), {
                                    ref: "formImage",
                                    onChange: handleImageChange,
                                    class: "upload-form",
                                    "file-list": []
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NUploadDragger), null, {
                                        default: _withCtx(() => [
                                          (imageFile.value || imageFileUrl.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createVNode(_unref(NButton), {
                                                  text: "",
                                                  class: "close-btn",
                                                  onClick: closeImagePreview
                                                }, {
                                                  icon: _withCtx(() => [
                                                    _createVNode(_unref(NIcon), null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(WindowClose))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("img", {
                                                  src: imageFileUrl.value,
                                                  alt: ""
                                                }, null, 8, _hoisted_10)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (!(imageFile.value || imageFileUrl.value))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_unref(NIcon), {
                                                    size: "48",
                                                    depth: 3
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(FileUploadOutline))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createVNode(_unref(NText), { style: {"font-size":"16px"} }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Drag file or click to upload ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_unref(NText), {
                                                  type: imageFileFeedback.value ? 'error' : '',
                                                  depth: "3",
                                                  style: {"margin":"8px 0 0 0"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(imageFileFeedback.value || "Max size is " + maxImageSize.value / (1024 ** 2) + "MB. Supported formats are JPEG, PNG, WebP, and SVG."), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["type"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NTabPane), {
                            name: "video",
                            tab: "Video"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(NUpload), {
                                  ref: "formVideo",
                                  onChange: handleVideoChange,
                                  class: "upload-form",
                                  "file-list": []
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NUploadDragger), null, {
                                      default: _withCtx(() => [
                                        (videoFile.value || videoFileUrl.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createVNode(_unref(NButton), {
                                                text: "",
                                                class: "close-btn",
                                                onClick: closeVideoPreview,
                                                style: {}
                                              }, {
                                                icon: _withCtx(() => [
                                                  _createVNode(_unref(NIcon), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(WindowClose))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("video", _hoisted_14, [
                                                _createElementVNode("source", {
                                                  ref: "videoSource",
                                                  src: videoFileUrl.value
                                                }, null, 8, _hoisted_15)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!(videoFile.value || videoFileUrl.value))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_unref(NIcon), {
                                                  size: "48",
                                                  depth: 3
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(FileUploadOutline))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _createVNode(_unref(NText), { style: {"font-size":"16px"} }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Drag file or click to upload ")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(NText), {
                                                type: videoFileFeedback.value ? 'error' : '',
                                                depth: "3",
                                                style: {"margin":"8px 0 0 0"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(videoFileFeedback.value || "Max size is " + maxVideoSize.value / (1024 ** 2) + "MB. Supported formats are MP4, MKV, and M4V."), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["type"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NSpace), { justify: "end" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                id: "backBtn",
                onClick: back,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }),
              _createVNode(_unref(NButton), {
                loading: submitLoading.value,
                "icon-placement": "left",
                id: "submitBtn",
                type: "primary",
                "attr-type": "submit",
                onClick: handleSubmit,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})